<script lang="ts" setup>
import HubCard from '@ui/composites/HubCard/HubCard.vue'
import Avatar from '@ui/components/Avatar/Avatar.vue'

import type { HubItem } from '~~/types/types'

defineProps<{
  reverse?: boolean
}>()

const { locale } = useI18n()
const localeRoute = useLocaleRoute()

const {
  public: { appLink },
} = useRuntimeConfig()

const take = 25

const queryData = computed(() => ({
  take,
  locale: locale.value,
}))

const pages = useState<{ data: HubItem[] }[]>('hubs', () => [])

const { data: firstPage } =
  await useNuxtApp().$client.hubs.getHubs.useQuery(queryData)

watch(
  firstPage,
  (value) => {
    pages.value = []

    if (value?.data.length) {
      if (!pages.value.length) {
        pages.value.push({
          data: value?.data,
        })
      }
    }
  },
  {
    immediate: true,
  }
)

const swiperBreakpoints = computed(() => ({
  320: { slidesPerView: 1.1 },
  640: { slidesPerView: 1.8 },
  1024: { slidesPerView: 2.8 },
  1440: { slidesPerView: 3.5 },
  1920: { slidesPerView: 4.5 },
  2560: { slidesPerView: 5.5 },
  3840: { slidesPerView: 6.5 },
}))
</script>

<template>
  <ClientOnly>
    <swiper-container
      :space-between="14"
      :loop="true"
      :autoplay="{
        delay: 2500,
        reverseDirection: reverse,
      }"
      :reverse-direction="true"
      :slidesOffsetBefore="14"
      :slidesOffsetAfter="14"
      :breakpoints="swiperBreakpoints"
    >
      <template v-for="{ data } in pages">
        <swiper-slide v-for="hub in data">
          <NuxtLink :to="localeRoute('/hubs/' + hub.slug)" class="no-underline">
            <HubCard
              :image="
                hub.mediaData?.coverImage?.large
                  ? `${appLink}/${hub.mediaData?.coverImage?.large}`
                  : ''
              "
              :coverImageDominantColors="
                hub.mediaData
                  ? Array.isArray(hub.mediaData.coverImageDominantColors)
                    ? hub.mediaData.coverImageDominantColors
                    : []
                  : []
              "
            >
              <template #title> {{ hub.title }} </template>
              <template v-if="hub.members" #subheader>
                {{ hub.members }} Members
              </template>
              <template #avatar>
                <Avatar
                  :url="
                    hub.mediaData?.coverImage?.large
                      ? `${appLink}/${hub.mediaData?.coverImage?.large}`
                      : ''
                  "
                />
              </template>
              <template v-if="hub.hubType === 'nftCollection'" #badge>
                <Icon
                  name="belong:hub-verified"
                  class="min-w-4.75 max-w-4.75 min-h-5 max-h-5 ml-2"
                />
              </template>
            </HubCard>
          </NuxtLink>
        </swiper-slide>
      </template>
    </swiper-container>
  </ClientOnly>
</template>
